import React from "react";
import Preloader from "../helper/Preloader";
import FooterOne from "../components/FooterOne";
import BottomFooter from "../components/BottomFooter";
import ScrollToTop from "react-scroll-to-top";
import HeaderOneVendorStore from "../componentsAmazon/HeaderOneVendorStore";
import Breadcrumb from "../components/Breadcrumb";
import Vendordashbord from "../componentsAmazon/Dashboard/Vendordashbord";

const DashboardVendor = () => {
 
 
  return (
    <>
      {/* Preloader */}
      <Preloader />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#232F3F" />

      {/* HeaderOneVendorStore */}
      <HeaderOneVendorStore />

      {/* Conditionally Render WholesaleCenter */}
      
       <Vendordashbord/>

      {/* FooterOne */}
      <FooterOne />

      {/* BottomFooter */}
      <BottomFooter />
    </>
  );
};

export default DashboardVendor;
